module.exports = __webpack_public_path__ + "static/media/monitoring.3a10947e.svg";